/**
 * 匿名ホットライン メッセージのやり取り状態 初期状態
 */
export const HOTLINE_MESSAGE_STATUS_DEFAULT = {
    label: '',
    value: 'default',
};
/**
 * 匿名ホットライン メッセージのやり取り状態 返信待ち
 */
export const HOTLINE_MESSAGE_STATUS_SENT = {
    label: '回答済',
    value: 'sent',
};
/**
 * 匿名ホットライン メッセージのやり取り状態 返信あり
 */
export const HOTLINE_MESSAGE_STATUS_RECEIVED = {
    label: '未返信',
    value: 'received',
};
/**
 * 匿名ホットライン メッセージのやり取り状態 一覧
 */
export const HOTLINE_MESSAGE_STATUSES = [
    HOTLINE_MESSAGE_STATUS_DEFAULT,
    HOTLINE_MESSAGE_STATUS_SENT,
    HOTLINE_MESSAGE_STATUS_RECEIVED,
];
